var i = Object.defineProperty, s = Object.defineProperties;
var u = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, C = Object.prototype.propertyIsEnumerable;
var c = (n, e, o) => e in n ? i(n, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : n[e] = o, t = (n, e) => {
  for (var o in e || (e = {}))
    m.call(e, o) && c(n, o, e[o]);
  if (r)
    for (var o of r(e))
      C.call(e, o) && c(n, o, e[o]);
  return n;
}, l = (n, e) => s(n, u(e));
import { jsx as P } from "react/jsx-runtime";
import { components as M } from "react-select";
function O(n) {
  return /* @__PURE__ */ P(M.Control, l(t({}, n), { innerProps: l(t({}, n.innerProps), {
    onClick: () => {
      n.menuIsOpen ? n.selectProps.onMenuClose() : n.selectProps.onMenuOpen();
    },
    onTouchStart: () => {
      n.menuIsOpen ? n.selectProps.onMenuClose() : n.selectProps.onMenuOpen();
    }
  }), children: n.children }));
}
O.displayName = "Control";
export {
  O as Control
};
//# sourceMappingURL=Control.es.js.map
